import { useNavigate } from 'react-router-dom'

import { Avatar, Box, Button, List, Text } from '@factorialco/deprecated-design-system'
import { EmployeesInlineEmployeeFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface MissingBankDetailsModalProps {
  onClose: () => void
  onSkip: () => void
  employeesWithoutBankAccount: Array<EmployeesInlineEmployeeFragment>
  canSkip: boolean
}

export const MissingBankDetailsModal = ({
  onClose,
  onSkip,
  employeesWithoutBankAccount,
  canSkip,
}: MissingBankDetailsModalProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const title = i18n.t('compensations.payments.missing_bank_details.title')

  const description = i18n.tp('compensations.payments.missing_bank_details.description', {
    count: employeesWithoutBankAccount.length,
  })

  const buttons = [
    <Button key="close" type="secondary" onClick={onClose}>
      {i18n.t('compensations.payments.missing_bank_details.close_button')}
    </Button>,
  ]

  if (canSkip) {
    buttons.push(
      <Button key="skip" onClick={onSkip}>
        {i18n.t('compensations.payments.missing_bank_details.skip_and_continue_button')}
      </Button>
    )
  }

  if (employeesWithoutBankAccount.length === 0) {
    return null
  }

  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      footer={<>{buttons}</>}
      onClose={onClose}
    >
      <List>
        {employeesWithoutBankAccount.map((employee) => (
          <List.Item key={employee.id}>
            <Box flexDirection="row" justifyContent="spaceBetween" gap="s12" width="full">
              <Box flexDirection="row" alignItems="center" gap="s12">
                <Avatar
                  label={employee.access.fullName}
                  url={buildUrl(employee.access.avatar)}
                  size="s32"
                />
                <Text.Normal size="300">{employee.access.fullName}</Text.Normal>
              </Box>

              <Button
                type="secondary"
                onClick={() =>
                  navigate(
                    navigation.employees.id.personal.fullPath({
                      id: String(employee.id),
                    })
                  )
                }
                iconName="external link"
              />
            </Box>
          </List.Item>
        ))}
      </List>
    </Modal>
  )
}
